<template>
  <form v-on:submit="save" action="#" method="post" id="">

    <div class="row">

      <div class="col-xs-4">
        <div class="form-group ">
          <label for="name" class="required">Company Name
            <span v-if="errorName" class="error">{{ errorName }}</span>
          </label>
          <input id="name" v-model="localCompany.name" class="form-control" required
                 :class="{'has-error' : errorName, 'has-success' : errorName === false}">
        </div>
      </div>

    </div>

    <div class="row">
      <div class="col-xs-4">
        <div class="form-group ">
          <label for="cpny_street">Address
            <span v-if="errorAddress1" class="error">{{ errorAddress1 }}</span>
          </label>
          <input v-model="localCompany.address1" id="cpny_street" class="form-control" :class="{'has-error'
          : errorAddress1, 'has-success' : errorAddress1 === false}">
        </div>
      </div>

      <div class="col-xs-2">
        <div class="form-group">
          <label for="zip_code">Zip Code
            <span v-if="errorZipCode" class="error">{{ errorZipCode }}</span>
          </label>
          <input v-model="localCompany.zip_code" id="zip_code" class="form-control" :class="{'has-error'
          : errorZipCode, 'has-success' : errorZipCode === false}">
        </div>
      </div>

      <div class="col-xs-3">
        <div class="form-group">
          <label for="city">City
            <span v-if="errorCity" class="error">{{ errorCity }}</span>
          </label>
          <input v-model="localCompany.city" id="city" class="form-control"  :class="{'has-error'
          : errorCity, 'has-success' : errorCity === false}">
        </div>
      </div>

      <div class="col-xs-3">
        <div class="form-group " >
          <label>Country
            <span v-if="errorCountry" class="error">{{ errorCountry }}</span>
          </label>

          <v-select2 id="consultant" :options="countries" label="name" v-model="localCompany.country" :searchable="true"
                    :class="{'has-error' : errorCountry, 'has-success' : errorCountry === false}"></v-select2>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-xs-4">
        <div class="form-group ">
          <label for="website">Website
            <span v-if="errorWebsite" class="error">{{ errorWebsite }}</span>
          </label>
          <input id="website" v-model="localCompany.website" class="form-control">
        </div>
      </div>
      <div class="col-xs-4">
        <div class="form-group ">
          <label for="main_activity">Main Activity
            <span v-if="errorMainActivity" class="error">{{ errorMainActivity }}</span>
          </label>
          <input id="main_activity" v-model="localCompany.main_activity" class="form-control"
                 :class="{'has-error' : errorMainActivity, 'has-success' : errorMainActivity === false}">
        </div>
      </div>

    </div>
    <div class="row">

      <div class="col-xs-12">
        <div class="form-group ">
          <label for="activity_overview">Activity Overview
            <span v-if="errorActivityOverview" class="error">{{ errorActivityOverview }}</span>
          </label>
          <textarea v-model="localCompany.activity_overview" id="activity_overview" class="form-control"
                    rows="3" cols="3" :class="{'has-error' : errorActivityOverview, 'has-success' : errorActivityOverview === false}"></textarea>
        </div>
      </div>

    </div>
    <div class="text-right m-t-xs">
      <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle">Save changes</vue-ladda>
    </div>
  </form>
</template>

<style >
</style>
<script>

import vSelect2 from '../../components/utils/select2'
import VueLadda from 'vue-ladda'

export default {
  components: {VueLadda, vSelect2},
  name: 'CompanyInformation',
  props: ['company', 'userId'],
  watch: {
    company: function (company) {
      this.initCompany()
    }
  },
  data () {
    return {
      localCompany: {
        name: null,
        address1: null,
        city: null,
        zip_code: null,
        website: null,
        main_activity: null,
        activity_overview: null
      },
      errorName: null,
      errorAddress1: null,
      errorCity: null,
      errorCountry: null,
      errorZipCode: null,
      errorWebsite: null,
      errorMainActivity: null,
      errorActivityOverview: null,

      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      countries: []
    }
  },
  methods: {
    save: async function (event) {
      event.preventDefault()
      this.submit.loading = true

      this.errorName = null
      this.errorAddress1 = null
      this.errorCity = null
      this.errorCountry = null
      this.errorZipCode = null
      this.errorWebsite = null
      this.errorMainActivity = null
      this.errorActivityOverview = null

      this.axios.patch('user/' + this.userId + '/companyInformation', {
        name: this.localCompany.name,
        address1: this.localCompany.address1,
        city: this.localCompany.city,
        zip_code: this.localCompany.zip_code,
        website: this.localCompany.website,
        main_activity: this.localCompany.main_activity,
        activity_overview: this.localCompany.activity_overview,
        country_id: this.localCompany.country === undefined ? null : this.localCompany.country.id
      }).then((response) => {
        this.$notify({
          type: 'success',
          title: 'Company Information is saved',
          placement: 'bottom-right'
        })
      }).catch((error) => {
        let errors = error.response.data.errors

        if (typeof errors['name'] !== 'undefined') {
          this.errorName = errors['name'][0]
        } if (typeof errors['address1'] !== 'undefined') {
          this.errorAddress1 = errors['address1'][0]
        } if (typeof errors['city'] !== 'undefined') {
          this.errorCity = errors['city'][0]
        } if (typeof errors['country_id'] !== 'undefined') {
          this.errorCountry = errors['country_id'][0]
        } if (typeof errors['zip_code'] !== 'undefined') {
          this.errorZipCode = errors['zip_code'][0]
        } if (typeof errors['website'] !== 'undefined') {
          this.errorWebsite = errors['website'][0]
        } if (typeof errors['main_activity'] !== 'undefined') {
          this.errorMainActivity = errors['main_activity'][0]
        } if (typeof errors['activity_overview'] !== 'undefined') {
          this.errorActivityOverview = errors['activity_overview'][0]
        }
      }).finally(() => {
        this.submit.loading = false
      })
    },
    getResources: function () {
      this.getCountries()
    },
    initCompany: function () {
      if (this.company !== null) {
        this.localCompany = this.company
      }
    },
    getCountries: function () {
      this.axios.get('/countries')
        .then((response) => {
          this.countries = response.data
        })
        .catch((error) => {
        })
    }
  },
  mounted () {
  },
  beforeMount () {
    this.getResources()
    this.initCompany()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/CompanyInformation.vue